<div
  class="page-support-request-wrapper container"
  [class.embedded-webview]="isEmbedded"
>
  <div class="container">
    <div class="row">
      <div class="col-lg-12 col-sm-12 mb-4 mt-4 text-center">
        <h1>Contact Us</h1>
      </div>
      <div class="col-lg-12 col-sm-12 mb-5">
        <form [formGroup]="supportForm" novalidate enctype="multipart/form-data" class="supportForm" (submit)="$event.preventDefault()">
          
          <div class="form-field mb-3">
            <label class="form-label" for="name">Name</label>
            <input
              type="text"
              id="name"
              name="name"
              formControlName="name"
              class="form-control"
              aria-label="Name"
              [attr.readonly]="nameLocked ? true : null"
              [class.locked-field]="nameLocked"
            >
            <div *ngIf="isInvalid('name')" class="invalid-feedback">
              Name is required
            </div>
          </div>

          <div class="form-field mb-3">
            <label class="form-label" for="email">Email</label>
            <input
              type="email"
              id="email"
              name="email"
              formControlName="email"
              class="form-control"
              aria-label="Email"
              [attr.readonly]="emailLocked ? true : null"
              [class.locked-field]="emailLocked"
            >
            <div *ngIf="isInvalid('email')" class="invalid-feedback">
              Email is required
            </div>
          </div>

          <div class="form-field mb-3 message-field">
            <label class="form-label" for="message">Message</label>
            <textarea id="message" rows="5" name="message" formControlName="message" class="form-control textarea" aria-label="Message"></textarea>
            <div *ngIf="isInvalid('message')" class="invalid-feedback">
              Message is required
            </div>
          </div>

          <div class="form-field mb-3 attachment-field">
            <label class="form-label" for="attachment">Attachment</label>
            <input
              type="file"
              class="form-control"
              id="attachment"
              name="attachment"
              accept="image/*,application/pdf,.pdf,.doc,.docx"
              (change)="onFileSelected($event)"
            >
          </div>

          <ng-container *ngIf="!isEmbedded">
            <div class="captcha-wrapper">
              <ngx-recaptcha2
                formControlName="captchaResponseControl"
                [siteKey]="siteKey"
                (ngxCaptchaCallback)="handleSuccess($event)"
                (ngxCaptchaExpired)="handleExpire()"
                (ngxCaptchaLoad)="handleLoad()"
              ></ngx-recaptcha2>
              <a href="javascript:void(0)" (click)="resetCaptcha()">
                reset
              </a>
            </div>
            <div *ngIf="isInvalid('captchaResponseControl')" class="invalid-feedback">
              Captcha is required
            </div>
          </ng-container>

          <!-- Never use [disabled] here: site CSS keeps disabled buttons looking enabled,
               but Bootstrap sets pointer-events:none so taps die in the WebView. -->
          <button
            type="button"
            class="btn btn-primary support-submit"
            (click)="onSubmit()"
            [attr.aria-busy]="submitting"
          >
            <div *ngIf="submitting" class="spinner-border" role="status">
              <span class="visually-hidden">Submitting...</span>
            </div>
            <span *ngIf="!submitting">Submit</span>
          </button>
          
          <div *ngIf="success" class="alert alert-success mt-3">
            Form submitted successfully
          </div>

          <div *ngIf="error" class="alert alert-danger mt-3">
            {{ error }}
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
